import { motion } from "framer-motion";
import {
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
  Mail,
  Phone,
  MapPin,
} from "lucide-react";

const footerLinks = {
  company: [
    { name: "About Us", href: "#about" },
    { name: "Services", href: "#services" },
    { name: "Products", href: "#products" },
    { name: "Contact", href: "#contact" },
  ],
  solutions: [
    { name: "Mobile Ordering", href: "#products" },
    { name: "QR Code System", href: "#products" },
    { name: "Digital Kiosk", href: "#products" },
    { name: "Analytics Dashboard", href: "#products" },
  ],
  resources: [
    { name: "Privacy Policy", href: "/privacy-policy" },
    { name: "Terms of Service", href: "/terms-conditions" },
    { name: "Support", href: "#contact" },
    { name: "FAQ", href: "/faqs" },
  ],
};

const socialLinks = [
  { icon: Facebook, href: "#", label: "Facebook" },
  { icon: Twitter, href: "#", label: "Twitter" },
  { icon: Linkedin, href: "#", label: "LinkedIn" },
  { icon: Instagram, href: "#", label: "Instagram" },
];

const Footer = () => {
  const scrollToSection = (href) => {
    if (href.startsWith("#")) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <footer className="bg-slate-900 text-slate-200" data-testid="footer">
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <a
              href="#home"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection("#home");
              }}
              className="inline-block mb-6"
            >
              <img
                src="https://s3-cc-prod.s3.ap-south-1.amazonaws.com/tistl/tistl_logo_transparent.png"
                alt="TISTL Logo"
                className="h-12 w-auto bg-white rounded-lg p-2"
              />
            </a>
            <p className="text-slate-400 leading-relaxed mb-6 max-w-sm">
              TISTL delivers cutting-edge digital cafeteria solutions through
              MyCafé Connect, empowering businesses in their digital
              transformation journey.
            </p>
            {/* <div className="flex items-center gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-[#0066CC] transition-colors duration-300"
                  aria-label={social.label}
                  data-testid={`social-link-${social.label.toLowerCase()}`}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div> */}
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(link.href);
                    }}
                    className="footer-link text-sm"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(" ", "-")}`}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Solutions Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Solutions</h4>
            <ul className="space-y-3">
              {footerLinks.solutions.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(link.href);
                    }}
                    className="footer-link text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#0066CC] flex-shrink-0 mt-0.5" />
                <span className="text-slate-400 text-sm">
                  Corporate Office: #404, 17th C Main Road, KHB Colony, 5th
                  Block, Koramangala, Bengaluru - 560095
                </span>
              </li>
              <li>
                <a
                  href="tel:+917406895747"
                  className="flex items-center gap-3 footer-link"
                >
                  <Phone className="w-5 h-5 text-[#0066CC]" />
                  <span className="text-sm">+91 7899576699</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:operations@tistl.in"
                  className="flex items-center gap-3 footer-link"
                >
                  <Mail className="w-5 h-5 text-[#0066CC]" />
                  <span className="text-sm">operations@tistl.in</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-400 text-sm">
              © {new Date().getFullYear()} TISTL (Tricube InnoSoft Technologies
              LLP). All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              {footerLinks.resources.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="footer-link text-sm"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
